import EventTracking from 'tc-event-tracking';

import moment from 'moment';
import { getUserToken } from "./modules/gms";

function initBookingMask() {
    var $bookingForm = $('.js-booking-form'),
        idBE = $bookingForm.data('bookingEngine');
        
    var BE = {
        urlParams: function (data) {
            var params = [];
            var languageId = this.getLanguageId(data.locale)
            var date_format = 'MM/DD/YYYY';

            if (data.datein) {
                params.push("datein" + "=" + moment(data.datein, 'MM/DD/YYYY').format(date_format));
            }
            if (data.dateout) {
                params.push("dateout" + "=" + moment(data.dateout, 'MM/DD/YYYY').format(date_format));
            }

            if (data.rooms) params.push("rooms" + "=" + data.rooms);
            if (data.adults) params.push("adults" + "=" + data.adults);

            if (data.children && data.children > 0) {
                params.push("children" + "=" + data.children);
            }

            if (data.discount && data.discount.length) {
                params.push("discount" + "=" + data.discount);
            }

            if (data.identifier && data.identifier.length) {
                params.push("identifier" + "=" + data.identifier);
            }

            if (data.iata && data.iata.length) {
                params.push("iata" + "=" + data.iata);
            }

            if (data.groupid && data.groupid.length) {
                params.push("groupid" + "=" + data.groupid);
            }

            if (data.confirmid && data.confirmid.length) {
                params.push("confirmid" + "=" + data.confirmid);
            }

            if (data.rateplanid && data.rateplanid.length) {
                params.push("rateplanid" + "=" + data.rateplanid);
            }

            if (languageId) {
                params.push("languageid=" + languageId);
            }

            if (getUserToken()) {
                params.push("token=" + getUserToken());
            }

            return params.join("&");

        },
        getLanguageId: function (locale) {
            var languageId = '1';
            switch (locale) {
                case 'es':
                    languageId = '2';
                    break;
                case 'fr':
                    languageId = '3';
                    break;
                case 'pt':
                    languageId = '4';
                    break;
                case 'zh-CN':
                    languageId = '5';
                    break;
                case 'ja':
                    languageId = '6';
                    break;
                case 'de':
                    languageId = '7';
                    break;
                case 'it':
                    languageId = '8';
                    break;
                case 'ru':
                    languageId = '9';
                    break;
                case 'nl':
                    languageId = '10';
                    break;
                case 'en':
                    languageId = '11';
                    break;
                case 'hu':
                    languageId = '13';
                    break;
                case 'el':
                    languageId = '14';
                    break;
                case 'ar':
                    languageId = '15';
                    break;
                case 'sv':
                    languageId = '16';
                    break;
                case 'no':
                    languageId = '17';
                    break;
                case 'cs':
                    languageId = '18';
                    break;
                case 'tr':
                    languageId = '19';
                    break;
                case 'ca':
                    languageId = '20';
                    break;
                case 'da':
                    languageId = '21';
                    break;
                case 'id':
                    languageId = '28';
                    break;
                case 'he':
                    languageId = '29';
                    break;
                case 'lt':
                    languageId = '25';
                    break;
                case 'ko':
                    languageId = '26';
                    break;
                case 'pl':
                    languageId = '27';
                    break;
                case 'hr':
                    languageId = '23';
                    break;
                case 'sk':
                    languageId = '24';
                    break;
                case 'lv':
                    languageId = '31';
                    break;
                case 'et':
                    languageId = '30';
                    break;
                case 'ro':
                    languageId = '32';
                    break;
                case 'is':
                    languageId = '33';
                    break;
                case 'fi':
                    languageId = '34';
                    break;
                case 'sl':
                    languageId = '35';
                    break;
                default:
                    languageId = '1';
            }
            return languageId;
        }
    };
    $('.destinations-bm__dropdown__list__link a').on('click', function(e){
        if ($(window).width() >= 768) {
            let selectedHotelId = $(this).attr('data-hotel'),
            customRateHolder = $('.custom-rate-select');

            e.preventDefault();
            e.stopImmediatePropagation(); // avoid triggering event tracking
            $(this).closest('.js-booking-form').attr('action', $(this).data('value')).trigger('BM_HOTEL_SELECTED');
            $('.modal-bm__close').trigger('click')
            $('.bm__hotel-chosen').text($(this).text());

            customRateHolder.each(function(){
                let currRateHolder = $(this),
                    rateSelects = currRateHolder.find('select');

                    rateSelects.each(function(){
                        $(this).removeClass('active-select');
                        $(this).val(null).trigger('change');
                    });

                    currRateHolder.parents('.js-custom-field-holder').removeClass('is-active');

                if(currRateHolder.find('.js-bm-promo[data-hotel="'+ selectedHotelId +'"]').length){
                    currRateHolder.find('.js-bm-promo[data-hotel="'+ selectedHotelId +'"]').addClass('active-select');
                    currRateHolder.parents('.js-custom-field-holder').removeClass('hide');
                }else{
                    currRateHolder.parents('.js-custom-field-holder').addClass('hide');
                }
            });
        }
    });

    /* When the user uses the "Special Rate" dropdown, we write
     * the type of discount + the discount in a hidden input
     * .js-bm-special-rate-target and we disable the related
     * discount field
    */
    $(document).on('change', '.js-bm-special-rate', (e) => {
        const $selectedOption = $('option:selected', e.target);
        const type = $selectedOption.data('type') || '';
        const $container = $selectedOption.closest('.js-booking-form');
        const $target = $container.find('.js-bm-special-rate-target');
        const $otherInputs = $container.find('.js-bm-promo:not(.js-bm-special-rate)');

        $otherInputs.removeAttr('disabled');
        $target.attr('name', type).val($selectedOption.val());
        if (type) {
            $otherInputs.filter(`[name=${type}]`).val('').attr('disabled','disabled');
        }
    });

    $bookingForm.on('submit', function(e, type=""){
        e.preventDefault();

        const $form = $(this);

        var arrayData = $(this).serializeArray();
        var data = {}
        arrayData.forEach(function (el) {
            data[el.name] = el.value
        });

        if(!data['promoCode']) {
            data['promoCode'] = $('input[name="promoCode"]').val();
        }

        if(type == 'modify') {
            data = {'confirmid': $('input[name="confirmid"]').val()}
        } else
        delete data['confirmid'];

        data.locale = $('html').attr('lang');

        var urlBE = $(this).attr('action'),
        bookingParameters = (BE.urlParams(data)),
        URL;

        if (!urlBE) {
            console.log("[[bm]] Action missing on form", $form);
            $form.trigger('BM_HOTEL_NOT_SELECTED');
            return;
        }

        if (urlBE.indexOf('_ga') < 0) {
            try {
                const _ga = window[window['GoogleAnalyticsObject']];

                let linkerParam;                

                if (_ga) linkerParam = _ga.getAll()[0].get('linkerParam');

                if (linkerParam) bookingParameters += `&${linkerParam}`;
            } catch (error) {
                console.error(error);
            }
        }

        if (urlBE.indexOf('#') > -1) {
            var before = urlBE.slice(0, urlBE.indexOf('#')),
            after = urlBE.slice(urlBE.indexOf('#'))
            URL = before + (before.indexOf('?') > -1 ? '&' : '?') + bookingParameters + after
        } else {
            URL = urlBE + (urlBE.indexOf('?') > -1 ? '&' : '?') + bookingParameters
        }

        if (URL) {
            console.log("[[bm]] - booking URL generated", URL)
            bookingTracking(data)
            window.open(URL, '_blank')
        } else {
            console.log("[[bm]] - could not generate booking URL")
        }
    });
}

const bookingTracking = data => {
    try {
        EventTracking.fireEvent('event.clickToBE.bookingMask');

        EventTracking.fireEvent('event.bookingIntention', {
            rooms: data.rooms,
            adults: data.adults,
            children: data.children,
            code: data.promoCode,
            dateIn: data.datein,
            dateOut: data.dateout,
            nights: moment(data.dateout, 'MM/DD/YYYY').diff(moment(data.datein, 'MM/DD/YYYY'), 'days'),
            promocode: data.promoCode
        });
    } catch (error) {
        console.log(error);
    }
}

export default initBookingMask;
